export const ExWarehouseRouting = [
  {
    path: "/material/exWarehouse/list",
    name: "basic-material-ex-warehouse-list",
    meta: { title: "出库单" },
    component: () =>
      import(
        /* webpackChunkName: "basic-material-library" */ "@/views/material/ex-warehouse/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/material/exWarehouse/create",
    name: "basic-material-ex-warehouse-create",
    meta: { title: "新增出库单" },comName:"MaterialExWarehouseFormCreate",
    component: () =>
      import(
        /* webpackChunkName: "basic-material-library" */ "@/views/material/ex-warehouse/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/material/exWarehouse/edit/:id",
    name: "basic-material-ex-warehouse-edit",
    meta: { title: "编辑出库单" },comName:"MaterialExWarehouseFormCreate",
    component: () =>
      import(
        /* webpackChunkName: "basic-material-library" */ "@/views/material/ex-warehouse/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/material/exWarehouse/detail/:id",
    name: "basic-material-ex-warehouse-detail",
    meta: { title: "出库单详情" },
    component: () =>
      import(
        /* webpackChunkName: "basic-material-library" */ "@/views/material/ex-warehouse/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/material/exWarehouse/flowPrint/:id",
    name: "material-exWarehouse-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "material-exWarehouse" */ "@/views/material/ex-warehouse/flow-print/index.vue"
      ),
  }
];
